import React from "react";

const StarIcon = ({ fill = "#333333", ...delegated }) => {
  return (
    <svg
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...delegated}
    >
      <path
        d="M16.9375 0.857666C17.5625 0.857666 18.0625 1.23267 18.3125 1.73267L22.625 10.5452L32.1875 11.9827C32.75 12.0452 33.1875 12.4202 33.375 12.9827C33.5625 13.5452 33.4375 14.1077 33 14.5452L26.0625 21.4202L27.6875 31.1077C27.8125 31.6702 27.5625 32.2952 27.125 32.6077C26.625 32.9202 26 32.9827 25.5 32.7327L16.9375 28.1077L8.4375 32.7327C7.875 32.9827 7.3125 32.9202 6.8125 32.6077C6.375 32.2327 6.125 31.6702 6.25 31.1077L7.875 21.4202L0.9375 14.5452C0.5 14.1077 0.375 13.5452 0.5625 12.9827C0.75 12.4827 1.1875 12.0452 1.75 11.9827L11.3125 10.5452L15.625 1.73267C15.875 1.23267 16.375 0.857666 16.9375 0.857666ZM16.9375 5.79517L13.6875 12.6077C13.4375 13.0452 13.0625 13.3577 12.5625 13.4202L5.1875 14.4827L10.5 19.7952C10.875 20.1702 11.0625 20.6702 10.9375 21.1077L9.6875 28.6077L16.25 25.1077C16.6875 24.8577 17.25 24.8577 17.6875 25.1077L24.25 28.6077L23 21.1702C22.875 20.6702 23.0625 20.1702 23.4375 19.8577L28.75 14.4827L21.375 13.4202C20.875 13.3577 20.5 13.0452 20.25 12.6077L16.9375 5.79517Z"
        fill={fill}
      />
    </svg>
  );
};

export { StarIcon };
